module.exports = __webpack_public_path__ + "static/img/video.4be9be4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/video.png
// module id = BXki
// module chunks = 15